import { Steps, Variant, VariantB, VariantC } from '../../types'
import * as Styles from './styles'

interface IProps {
  variant: Variant
  nextStep?: Steps
  prevStep?: Steps
  activeStep: Steps
  backButtonText?: string
  continueButtonText?: string
  setStep: (step: Steps) => void
  onFinish?: () => void
}

export const StepsActions = ({
  variant,
  nextStep,
  activeStep,
  prevStep,
  backButtonText,
  continueButtonText,
  setStep,
  onFinish,
}: IProps) => {
  const stepsType = variant === 'b' ? VariantB : VariantC
  const steps = Object.values(stepsType).map(item => item)

  const onNextStep = () => {
    if (nextStep) {
      setStep(nextStep)
    } else {
      onFinish?.()
    }
  }

  const onPreviousStep = () => {
    if (!prevStep) return
    setStep(prevStep)
  }

  return (
    <Styles.Container>
      <Styles.StepsCounter>
        {steps.map((step: Steps) => (
          <Styles.Step key={step} active={step === activeStep} />
        ))}
      </Styles.StepsCounter>
      <Styles.Actions>
        {prevStep && (
          <Styles.BackButton onClick={onPreviousStep}>{backButtonText || 'Back'}</Styles.BackButton>
        )}
        <Styles.ContinueButton onClick={onNextStep}>
          {continueButtonText || 'Continue'}
        </Styles.ContinueButton>
      </Styles.Actions>
    </Styles.Container>
  )
}
